<template>
    <div class="share-wraper">
        <TxButton :src="src" class="t-btn group" name="一键入群" @click="is_show = true">
            <TxImage v-if="is_show_tips" class="join-tips" src="qipao"/>
        </TxButton>
        <TxDialog v-model="is_show">
            <div class="dialog-content">
                <TxImage class="erweima" :size="{ width: 170, height: 170 }" src="erweima" />
            </div>
        </TxDialog>
    </div>
</template>
<script setup>
const is_show = ref(false);
const props = defineProps({
    src: {
        type: String,
    },
    is_show_tips:{
        type: Boolean,
        default:false
    }
});
</script>
<style lang="scss" scoped>
.dialog-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 24px;
    // @include bg('shequn-diban');
}

.erweima {
    position: relative;
    top: 135px;
}

.join-tips{
    position: absolute;
    top: 0px;
    right: 0px;
}
.group{
    position: relative;
}
</style>
